import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "v-bar-chart" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "count" }
const _hoisted_4 = {
  class: "svg-chart",
  height: "150",
  width: "434"
}
const _hoisted_5 = ["y"]
const _hoisted_6 = ["y1", "y2"]
const _hoisted_7 = ["x", "y", "height", "fill", "onMouseenter"]
const _hoisted_8 = ["x", "y", "width", "height", "fill", "onMouseenter"]

import { computed } from 'vue';
import { num } from '@/utils/lang'
import { useUiStore } from '@/stores/ui';


export default /*#__PURE__*/_defineComponent({
  __name: 'VBarChart',
  props: {
    data: null,
    title: null,
    tooltip: null
  },
  setup(__props: any) {

const props = __props as { data: {[ key: string ]: number | number[] }, title?: string, tooltip: (...args: any) => string }



const grad = [ 5, 10, 25, 50, 100, 200, 250, 500, 1000 ]
const agg = computed(() => {
  let max = 0
  let count = 0
  for (let value of Object.values<number | number[]>(props.data)) {
    if (Array.isArray(value)) {
      for (let val of value) {
        max = Math.max(val, max)
        count += val
      }
    } else {
      max = Math.max(value, max)
      count += value
    }
  }
  max = grad.find(val => max < val) || max
  let gradStep = 5
  if (max === 200) {
    gradStep = 4
  }
  return { max, count, gradStep }
})

const colors = [
  "#EF7575",
  "#EFC675",
  "#EFEA75",
  "#C8EF75",
  "#6CCB86"
]

const uiStore = useUiStore()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(props.title) + " ", 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(num)(_unref(agg).count, "ответ", "ответа", "ответов")), 1)
    ]),
    (_openBlock(), _createElementBlock("svg", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref(agg).gradStep+1), (i) => {
        return (_openBlock(), _createElementBlock("text", {
          x: "2",
          y: ((10+(i-1)*(135 / _unref(agg).gradStep)) + 4)
        }, _toDisplayString(_unref(agg).max / _unref(agg).gradStep * (_unref(agg).gradStep-i+1)), 9, _hoisted_5))
      }), 256)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref(agg).gradStep+1), (i) => {
        return (_openBlock(), _createElementBlock("line", {
          x1: "22",
          y1: (10+(i-1)*(135 / _unref(agg).gradStep)),
          x2: "434",
          y2: (10+(i-1)*(135 / _unref(agg).gradStep)),
          stroke: "rgba(0, 0, 0, 0.1)"
        }, null, 8, _hoisted_6))
      }), 256)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (value, key, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (!Array.isArray(value))
            ? (_openBlock(), _createElementBlock("rect", {
                key: 0,
                x: (35+80*index),
                y: (145-(value/_unref(agg).max) * 135),
                width: "65",
                height: (value/_unref(agg).max) * 135,
                fill: colors[index],
                onMouseenter: ($event: any) => (_unref(uiStore).openTooptip($event, props.tooltip(value, _unref(agg).count)))
              }, null, 40, _hoisted_7))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(value, (item, index2) => {
                return (_openBlock(), _createElementBlock("rect", {
                  x: (35+80*index + index2*(67 / value.length)),
                  y: (145-(item/_unref(agg).max) * 135),
                  width: (65 / value.length)-2,
                  height: (item/_unref(agg).max) * 135,
                  fill: colors[index],
                  onMouseenter: ($event: any) => (_unref(uiStore).openTooptip($event, props.tooltip(item, _unref(agg).count, index2)))
                }, null, 40, _hoisted_8))
              }), 256))
        ], 64))
      }), 256))
    ]))
  ]))
}
}

})